import { render, staticRenderFns } from "./ScoringModeSelector.vue?vue&type=template&id=f776e524&scoped=true"
import script from "./ScoringModeSelector.vue?vue&type=script&lang=js"
export * from "./ScoringModeSelector.vue?vue&type=script&lang=js"
import style0 from "./ScoringModeSelector.vue?vue&type=style&index=0&id=f776e524&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f776e524",
  null
  
)

export default component.exports